<template>
  <v-container id="dashboard-view" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <!-- <v-row>
           <v-col
            v-for="(chart, i) in charts"
            :key="`chart-${i}`"
            cols="12"
            md="6"
            lg="4"
          >
            <material-chart-card
              :color="chart.color"
              :data="chart.data"
              :options="chart.options"
              :responsive-options="chart.responsiveOptions"
              :title="chart.title"
              :type="chart.type"
            >
              <template #subtitle>
                <div class="font-weight-light text--secondary">
                  <div v-html="chart.subtitle" />
                </div>
              </template>

              <template #actions>
                <v-icon
                  class="mr-1"
                  small
                >
                  mdi-clock-outline
                </v-icon>

                <span
                  class="text-caption grey--text font-weight-light"
                  v-text="chart.time"
                />
              </template>
            </material-chart-card>
          </v-col>
        </v-row> -->
      </v-col>

      <v-col
        v-for="({ actionIcon, actionText, ...attrs }, i) in stats"
        :key="i"
        cols="12"
        md="6"
        lg="3"
      >
        <material-stat-card v-bind="attrs" :loading="loadinStat">
          <template #actions>
            <v-icon class="mr-2" small v-text="actionIcon" />
            <div class="text-truncate">
              {{ actionText }}
            </div>
          </template>
        </material-stat-card>
      </v-col>

      <v-col cols="12" md="6">
        <material-card color="orange" class="mt-15" full-header height="700">
          <template #heading>
            <div class="pa-8 white--text">
              <div class="text-h4 font-weight-light">
                Latest Uploads
              </div>
              <!-- <div class="text-caption">
                New employees on 15th September, 2016
              </div> -->
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="userData.shared"
              no-data-text="You have not uploaded any files yet"
            />
          </v-card-text>
        </material-card>
      </v-col>
      <v-col cols="12" md="6">
        <material-card color="primary" class="mt-15" full-header height="700">
          <template #heading>
            <div class="pa-8 white--text">
              <div class="text-h4 font-weight-light">
                Recently recieved
              </div>
            </div>
          </template>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="recievedFiles"
              no-data-text="You have not recieved any files yet"
            />
          </v-card-text>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Utilities
import { get } from "vuex-pathify";
import axios from "axios";

export default {
  name: "DashboardView",

  data: () => ({
    currentUser: {},
    userData: {},
    headers: [
      {
        sortable: false,
        text: "ID",
        value: "id"
      },
      {
        sortable: false,
        text: "Name",
        value: "name"
      },
      {
        sortable: false,
        text: "File Type",
        value: "media[0].ext",
        align: "right"
      }
    ],
    loadinStat: false
  }),

  computed: {
    sales: get("sales/sales"),
    totalSales() {
      return this.sales.reduce((acc, val) => acc + val.salesInM, 0);
    },
    usedSpace() {
      const files = this.userData.shared ? this.userData.shared : [];
      let used = 0;
      files.forEach(file => {
        used = used + file.media[0].size;
      });
      const total = used / 1024;
      return total.toFixed(1);
    },
    recievedFiles() {
      return this.userData.recievedFiles;
    },
    stats() {
      return [
        {
          actionIcon: "mdi-alert",
          actionText: "Used space",
          color: "#FD9A13",
          icon: "mdi-cloud-check-outline",
          title: "Space Used",
          value: `${this.usedSpace} MB`
        },
        {
          actionIcon: "mdi-tag",
          actionText: "Files you've shared",
          color: "primary",
          icon: "mdi-cloud-upload",

          title: "Sent",
          value: `${
            this.userData.sharedNumber ? this.userData.sharedNumber : 0
          }`
        },
        {
          actionIcon: "mdi-calendar-range",
          actionText: "Since signup",
          color: "success",
          icon: "mdi-cloud-download",
          title: "Recieved",
          value: this.userData.recievedFiles
            ? `${this.userData.recievedFiles.length}`
            : "0"
        },
        {
          actionIcon: "mdi-history",
          actionText: "Just Updated",
          color: "info",
          icon: "mdi-database",
          title: "Total",
          value: "300MB"
        }
      ];
    }
  },
  methods: {
    async getSpace() {
      this.loadinStat = true;
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      try {
        const filesUrl = `${process.env.VUE_APP_BASE_URL}/upload/files`;
        const fileResponse = await axios.get(filesUrl);
        console.log(fileResponse);
      } catch (error) {
        console.log(error);
        this.$toast.error("Could not get available space, please refresh");
      } finally {
        this.loadinStat = false;
      }
    },
    async getCurrentUser() {
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      try {
        const userUrl = `${process.env.VUE_APP_BASE_URL}/users/me`;
        const userResponse = await axios.get(userUrl);
        const userDataUrl = `${process.env.VUE_APP_BASE_URL}/users/${userResponse.data.id}`;
        const userResponseData = await axios.get(userDataUrl);
        this.currentUser = userResponse.data;
        this.userData = userResponseData.data;
        console.log(userResponseData);
      } catch (error) {
        this.$toast.error("Something went wrong getting user");
      }
    }
  },
  mounted() {
    const AuthToken = localStorage.getItem("AuthToken");
    if (AuthToken) {
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      this.getSpace();
      this.getCurrentUser();
    } else {
      this.$router.push("/login");
    }
  }
};
</script>
